"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
var angular = require("angular");
var table_input_logic_1 = require("../table-input2/table-input.logic");
var basic_table_component_1 = require("../basic-component/basic-table.component");
var history_modal_component_1 = require("./history-modal/history-modal.component");
var so_rich_text_box_component_1 = require("../../../components/so-rich-text-box/so-rich-text-box.component");
var inav_utils_service_1 = require("../../../components/utils/inav-utils.service");
var issue_list_1 = require("../../../components/utils/issue-list/issue-list");
require('./table-input-mult.component.css');
var COMPONENT_NAME = 'smartorg.r6.acts.tableInputMult';
var COL_CONSTS = { GMF: 4, CU: 5 };
var ALLOWED_ACTIVITIES = [
    'Demand Generation',
    'Marketing Communications',
    'Market Intelligence/Research',
    'Training Materials',
    'Other'
];
var TableInputMultComponent = /** @class */ (function () {
    function TableInputMultComponent($scope, $timeout, uiGridEditConstants) {
        var _this = this;
        var rootScope = $scope.$root;
        this.$scope = $scope;
        this.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        this.reloadData = function () { return $scope.$emit('workbench:reloadAction'); };
        this.utilsService = new inav_utils_service_1.UtilsService(issue_list_1.IssueListEnum.DEFAULT);
        this.lastUpdated = function () { return $scope.$emit('workbench:last_updated', { nodeID: _this.node._id }); };
        this.updateNodeIsDataValid = function () { return $scope.$emit('workbench:update_isDataValid', {
            nodeIdList: [_this.node._id],
            isDataValid: _this.isCommonData !== 'true'
        }); };
        this.setGlobalDirty = function (dirty) {
            rootScope.smartorgDirty = dirty;
        };
        $scope.$on('command:TABLE_MULTIPLE_INPUT', function (event, args) {
            _this.loading = true;
            _this.cleanup();
            $timeout(function () {
                try {
                    _this.loadMultipleTables(args, uiGridEditConstants);
                    _this.menu = _this.getMenu();
                }
                catch (err) {
                    _this.showAlert('danger', "Error!", err);
                }
                finally {
                    _this.loading = false;
                }
            });
        });
    }
    TableInputMultComponent.prototype.$onDestroy = function () {
        this.destroyed = true;
    };
    TableInputMultComponent.prototype.loadMultipleTables = function (args, uiGridEditConstants) {
        var _this = this;
        var commonData = args.commonData, readOnly = args.readOnly, actionMenuItem = args.actionMenuItem, data = args.config.data;
        this.username = data.user;
        this.readonly = readOnly;
        this.isMultiple = true;
        this.justCalculated = false;
        this.tablesData = [];
        this.gotDirty = false;
        this.filterApplied = false;
        this.deleteRowFlag = false;
        this.summationColHeaders = ["Major Activities", "Type of Activity", "Who", "Due By", "Global Marketing Funds (thousand $)", "Commercial Expenses CU (thousand $)", "Delete"];
        this.hotTables = [];
        this.configData = { data: [], originData: [] };
        this.filterAppliedCols = [];
        if (commonData) {
            var nodeID = data.nodeID, nodeName = data.nodeName, tableDefn = data.tableDefn;
            this.tableDef = tableDefn[0];
            var _a = this.tableDef, Inherited = _a.Inherited, InputType = _a.InputType;
            this.tableDef.Inherited = Inherited && InputType === 'INHERITED';
            this.node = { _id: nodeID, name: nodeName };
            this.initComments(this.tableDef.Comment);
            this.tableInput = new table_input_logic_1["default"](this.node, this.tableDef, null, null);
            this.gridOptions = this.tableInput.getGridOptions(this.readonly, uiGridEditConstants, this.showAlert);
        }
        else {
            var node = args.node, compareToNode = args.compareToNode;
            this.node = node;
            var main = data.main, sibling = data.sibling, settings = data.settings;
            if (!this.verifyTemplateAndNode(main, sibling)) {
                return;
            }
            this.readonly = this.readonly || main.readOnly;
            this.tableDef = main.tableDef[0];
            this.tableDef2 = main.tableDef[1];
            var mainTable = main.tableDef[0];
            var mainTable2 = main.tableDef[1];
            var siblingTable = sibling ? sibling.tableDef : null;
            this.initComments(this.tableDef.Comment);
            this.title = actionMenuItem + " for " + node.name;
            this.tableInput = new table_input_logic_1["default"](node, mainTable, compareToNode, siblingTable);
            this.tableInput2 = new table_input_logic_1["default"](node, mainTable2, compareToNode, siblingTable);
            this.gridOptions = this.tableInput.getGridOptions(this.readonly, uiGridEditConstants, this.showAlert);
            var mainReference = main.referenceData;
            var siblingReference = sibling ? sibling.referenceData : {};
            var decimals = (0, basic_table_component_1.loadSettings)(args.treeName, settings).decimals;
            this.referenceData = (0, table_input_logic_1.getReferenceData)(mainReference, siblingReference, decimals);
            this.configData = { data: main.gmfSummation, originData: angular.copy(main.gmfSummation) };
            this.baseYear = main.tableDef[0].Val.ColHeaders[0];
            main.tableDef.map(function (d, i) {
                var newDiv = document.createElement("div");
                var idCustom = d.Key;
                newDiv.setAttribute("id", idCustom);
                var currentDiv = document.getElementById("handson-area");
                var brLine = document.createElement("br");
                currentDiv.appendChild(newDiv);
                currentDiv.appendChild(brLine);
                currentDiv.appendChild(brLine);
                var tableData = { data: d, originData: __assign(__assign({}, angular.copy(d)), { Val: angular.copy(d.Val) }) };
                _this.tablesData.push(tableData);
                _this.showIt(d, idCustom, tableData.originData);
            });
            this.showSummation();
        }
        this.commentDisabled = (this.isCommonData && this.tableDef.InputType === 'INHERITED') ||
            (!this.isCommonData && this.tableDef.Inherited);
    };
    TableInputMultComponent.prototype.decode = function (string) {
        try {
            return decodeURIComponent(string);
        }
        catch (e) {
            return string;
        }
    };
    TableInputMultComponent.prototype.initComments = function (comments) {
        this.commentHistory = comments;
        if (this.commentHistory && this.commentHistory.length > 0) {
            var _a = this.commentHistory[this.commentHistory.length - 1], SavedBy = _a.SavedBy, SavedOn = _a.SavedOn, msg = _a.msg, universalTableComment = _a.universalTableComment;
            var decodedMsg = this.decode(msg);
            this.currentComment = {
                savedBy: SavedBy,
                savedOn: SavedOn,
                msg: decodedMsg,
                originMsg: decodedMsg,
                universalTableComment: universalTableComment
            };
        }
        else {
            this.currentComment = { msg: '', originMsg: '', universalTableComment: '' };
        }
    };
    TableInputMultComponent.prototype.cleanup = function () {
        if (this.tableInput && this.tableInput.onDestroy) {
            this.tableInput.onDestroy();
        }
        this.tableInput = {};
        this.errMessage = null;
        this.commentHistory = null;
        this.currentComment = { msg: '', originMsg: '' };
        this.tableDef = null;
        this.isMultiple = false;
        this.title = '';
        this.saving = false;
        document.getElementById("handson-area").innerHTML = "";
        document.getElementById("handson-gmf").innerHTML = "";
        document.getElementById("handson-gmf-summation").innerHTML = "";
        if (this.gridOptions) {
            this.gridOptions = null;
        }
    };
    TableInputMultComponent.prototype.verifyTemplateAndNode = function (main, sibling) {
        if (!main || !sibling) {
            this.errMessage = null;
            return true;
        }
        if (main.leafOrPlatform !== sibling.leafOrPlatform) {
            var nodeTypeStr = main.leafOrPlatform === 'leaf' ? 'basic' : 'platform';
            this.errMessage = 'Compare Inputs are only available for the same kind of nodes. ' +
                ("The selected node is a " + nodeTypeStr + " node, ") +
                ("it can only be compared with another " + nodeTypeStr + " node.");
            return false;
        }
        if (main.template !== sibling.template) {
            this.errMessage = 'Compare Table Inputs are only available for ' +
                'the same templates. ' +
                'Selected nodes are using different templates. ';
            return false;
        }
        return true;
    };
    TableInputMultComponent.prototype.override = function () {
        this.overrideInput({
            targetNodeId: this.node._id,
            sourceNodeId: this.tableDef.rootID,
            inputKey: this.tableDef.Key
        });
    };
    TableInputMultComponent.prototype.deleteRow = function (ctrl, coords) {
        bootbox.dialog({
            message: "You are about to delete this row. Are you sure?",
            title: "Confirm Deletion",
            buttons: {
                confirm: {
                    label: "Delete",
                    className: "btn-danger",
                    callback: function () {
                        ctrl.configHotTable.alter('remove_row', coords.row);
                        ctrl.deleteRowFlag = true;
                        ctrl.gotDirty = ctrl.checkDirtiness();
                        ctrl.$scope.$apply();
                        ctrl.calcTotal(COL_CONSTS.GMF);
                        ctrl.calcTotal(COL_CONSTS.CU);
                        ctrl.deleteRowFlag = false;
                    }
                },
                cancel: {
                    label: "Cancel",
                    className: "btn-primary"
                }
            }
        });
    };
    TableInputMultComponent.prototype.addRow = function () {
        var _this = this;
        var col = this.configHotTable.countRows();
        setTimeout(function () {
            _this.configHotTable.alter('insert_row', col, 1);
            if (_this.filterApplied) {
                _this.configHotTable.getPlugin('Filters').clearConditions();
                _this.configHotTable.getPlugin('Filters').filter();
                _this.filterApplied = false;
            }
            _this.gotDirty = _this.checkDirtiness();
            _this.$scope.$apply();
        }, 50);
    };
    TableInputMultComponent.prototype.showIt = function (dataGot, divGot, originDataGot) {
        var data = dataGot.Val.Data;
        var originData = originDataGot.Val.Data;
        var colHeaders = dataGot.Val.ColHeaders;
        colHeaders = colHeaders.map(function (c) {
            c = { type: "numeric" };
            return c;
        });
        var ctrl = this;
        var container = document.getElementById(divGot);
        var hot = new Handsontable(container, {
            data: data,
            columns: colHeaders,
            rowHeaders: dataGot.Val.RowHeaders,
            colHeaders: dataGot.Val.ColHeaders,
            filters: false,
            cells: function (row, col, prop) {
                var cellProperties = {};
                if (col === 0 && divGot == "CUnGMFTable") { // first column
                    cellProperties.readOnly = true;
                }
                return cellProperties;
            },
            stretchH: "all",
            height: "auto",
            // width: "100%",
            rowHeaderWidth: 250,
            licenseKey: "ee979-f3485-d8862-46b42-8ee23",
            afterGetRowHeader: function (row, TH) {
                if (row === 0 || row === 1) { // column index for 'globalMarketin
                    TH.style.whiteSpace = 'normal';
                    TH.style.textAlign = 'justify';
                }
            },
            beforeChange: function (changes, source) {
                var numericRegex = /^-?\d+(\.\d+)?$/;
                for (var i = 0; i < changes.length; i++) {
                    var row = changes[i][0];
                    var col = changes[i][1];
                    var oldValue = changes[i][2];
                    var newValue = changes[i][3];
                    // If the new value is not a number, set it to 0
                    if (!numericRegex.test(newValue)) {
                        changes[i][3] = 0;
                    }
                }
            },
            afterChange: function (changes, source) {
                if (source === 'edit') {
                    for (var i = 0; i < changes.length; i++) {
                        var row = this.toPhysicalRow(changes[i][0]);
                        var col = changes[i][1];
                        var oldValue = originData[row][col];
                        // let oldValue = changes[i][2];
                        var newValue = changes[i][3];
                        if (oldValue != newValue && ctrl.gotDirty != true) {
                            ctrl.gotDirty = true;
                            ctrl.$scope.$apply();
                        }
                        else if (ctrl.gotDirty) {
                            ctrl.gotDirty = ctrl.checkDirtiness();
                            ctrl.$scope.$apply();
                        }
                    }
                }
            }
        });
        this.hotTables.push(hot);
        if (divGot == "CUnGMFTable") {
            this.CGMFTable = hot;
        }
    };
    TableInputMultComponent.prototype.checkDirtiness = function () {
        var dirty = false;
        var tempConfigData = angular.copy(this.configData);
        var configDataForChk = __spreadArray([], tempConfigData.data, true);
        if (configDataForChk.length != this.configData.originData.length) {
            dirty = true;
        }
        if (!dirty) {
            this.tablesData.map(function (td) {
                var data = td.data.Val.Data;
                var originData = td.originData.Val.Data;
                for (var i = 0; i < data.length; i++) {
                    for (var j = 0; j < data[i].length; j++) {
                        if (data[i][j] != originData[i][j]) {
                            dirty = true;
                            break;
                        }
                    }
                }
            });
        }
        //checking dirtiness only if it's still false      
        if (!dirty) {
            var data = configDataForChk;
            var originData = this.configData.originData;
            for (var i = 0; i < data.length; i++) {
                for (var j = 0; j < Object.keys(data[i]).length; j++) {
                    if (data[i][j] != originData[i][j]) {
                        dirty = true;
                        break;
                    }
                }
            }
        }
        return dirty;
    };
    TableInputMultComponent.prototype.showSummation = function () {
        var ctrl = this;
        var newDiv = document.createElement("div");
        var idCustom = "hotTableActivity";
        newDiv.setAttribute("id", idCustom);
        var currentDiv = document.getElementById("handson-gmf");
        var brLine = document.createElement("br");
        currentDiv.prepend(newDiv);
        var currentYear = this.baseYear;
        var quarters = [["Q1 " + currentYear], ["Q2 " + currentYear], ["Q3 " + currentYear], ["Q4 " + currentYear]];
        var quartersArr = quarters.map(function (v) { return v[0]; });
        var container = document.getElementById(idCustom);
        this.configHotTable = new Handsontable(container, {
            data: this.configData.data,
            rowHeaders: false,
            colHeaders: this.summationColHeaders,
            colWidths: [70, 80, 50, 50, 40, 50, 25],
            columnSorting: true,
            filters: true,
            dropdownMenu: [
                "filter_by_value",
                "filter_action_bar",
                "filter_by_condition",
            ],
            stretchH: "all",
            height: "auto",
            // width: "50%",
            licenseKey: "ee979-f3485-d8862-46b42-8ee23",
            afterGetColHeader: function (col, TH) {
                if (col === 6) {
                    var button = TH.querySelector(".changeType");
                    if (!button) {
                        return;
                    }
                    button.parentElement.removeChild(button);
                }
                if (col === 4 || col === 5) { // column index for 'globalMarketin
                    TH.style.whiteSpace = 'normal';
                    TH.style.textAlign = 'justify';
                }
                else {
                    TH.className = 'htMiddle htCenter';
                }
            },
            afterChange: function (changes, source) {
                if (source === 'loadData' || source === 'setDataAtCell') {
                    // If data is being updated programmatically, do nothing to avoid infinite loop
                    return;
                }
                if (source === 'edit') {
                    for (var i = 0; i < changes.length; i++) {
                        var row = this.toPhysicalRow(changes[i][0]);
                        var colGot = changes[i][1];
                        var oldValue = row < ctrl.configData.originData.length ? ctrl.configData.originData[row][colGot] : '';
                        var newValue = changes[i][3];
                        if (oldValue != newValue && ctrl.gotDirty != true) {
                            ctrl.gotDirty = true;
                            ctrl.$scope.$apply();
                        }
                        else if (ctrl.gotDirty) {
                            ctrl.gotDirty = ctrl.checkDirtiness();
                            ctrl.$scope.$apply();
                        }
                    }
                    var col = changes[0][1];
                    ctrl.calcTotal(col);
                }
            },
            columns: [
                { className: "htCenter htMiddle" },
                {
                    renderer: function (instance, td, row, col, prop, value, cellProperties) {
                        var comboBox = document.createElement("select");
                        if (!ALLOWED_ACTIVITIES.includes(value)) {
                            var currentValueOption = document.createElement("option");
                            currentValueOption.value = value;
                            currentValueOption.textContent = value;
                            comboBox.appendChild(currentValueOption);
                        }
                        // Populate the combo box with options
                        ALLOWED_ACTIVITIES.forEach(function (option) {
                            var optionElement = document.createElement("option");
                            optionElement.value = option;
                            optionElement.textContent = option;
                            comboBox.appendChild(optionElement);
                        });
                        comboBox.value = value;
                        comboBox.classList.add("handson-dropdown");
                        comboBox.addEventListener("change", function () {
                            instance.setDataAtCell(row, col, comboBox.value);
                        });
                        Handsontable.dom.empty(td);
                        td.appendChild(comboBox);
                    },
                    readOnly: true
                },
                {
                    type: "text", className: "htCenter htMiddle"
                },
                {
                    renderer: function (instance, td, row, col, prop, value, cellProperties) {
                        var comboBox = document.createElement("select");
                        if (!quartersArr.includes(value)) {
                            var currentValueOption = document.createElement("option");
                            currentValueOption.value = value;
                            currentValueOption.textContent = value;
                            comboBox.appendChild(currentValueOption);
                        }
                        // Populate the combo box with options
                        quartersArr.forEach(function (option) {
                            var optionElement = document.createElement("option");
                            optionElement.value = option;
                            optionElement.textContent = option;
                            comboBox.appendChild(optionElement);
                        });
                        comboBox.value = value;
                        comboBox.classList.add("handson-dropdown");
                        comboBox.addEventListener("change", function () {
                            instance.setDataAtCell(row, col, comboBox.value);
                        });
                        Handsontable.dom.empty(td);
                        td.appendChild(comboBox);
                    },
                    readOnly: true
                },
                { type: "numeric", className: "htCenter htMiddle" },
                { type: "numeric", className: "htCenter htMiddle" },
                { className: "htCenter htMiddle" },
            ],
            afterOnCellMouseDown: function (event, coords) {
                var indexGotHere = this.toPhysicalRow(coords.row);
                if (coords.col == 6) {
                    ctrl.deleteRow(ctrl, coords);
                }
            },
            beforeChange: function (changes, source) {
                var numericRegex = /^-?\d+(\.\d+)?$/;
                for (var i = 0; i < changes.length; i++) {
                    var row = changes[i][0];
                    var col = changes[i][1];
                    var oldValue = changes[i][2];
                    var newValue = changes[i][3];
                    if (col === 4 || col === 5) {
                        // If the new value is not a number, set it to 0
                        if (!numericRegex.test(newValue)) {
                            changes[i][3] = 0;
                        }
                    }
                    if (col === 1 && ALLOWED_ACTIVITIES.indexOf(newValue) === -1) {
                        changes[i][3] = '';
                    }
                    if (col === 3 && quartersArr.indexOf(newValue) === -1) {
                        changes[i][3] = '';
                    }
                }
            }
        });
        this.configHotTable.addHook('afterFilter', function (args) {
            var filteredColumns = args.map(function (filter) { return filter.column; });
            ctrl.filterAppliedCols = filteredColumns;
            ctrl.filterApplied = filteredColumns.length > 0;
            ctrl.$scope.$apply();
        });
        this.configHotTable.addHook('afterGetColHeader', function (col, TH) {
            var TR = TH.parentNode;
            var THEAD = TR.parentNode;
            var headerLevel = (-1) * THEAD.childNodes.length + Array.prototype.indexOf.call(THEAD.childNodes, TR);
            function applyClass(elem, className) {
                if (!Handsontable.dom.hasClass(elem, className)) {
                    Handsontable.dom.addClass(elem, className);
                }
            }
            // Remove the class 'filter-applied-col' from all columns initially
            Handsontable.dom.removeClass(TH, 'filter-applied-col');
            // Apply the class 'filter-applied-col' to columns with active filters
            if (ctrl.filterAppliedCols && ctrl.filterAppliedCols.includes(col)) {
                applyClass(TH, 'filter-applied-col');
            }
        });
        this.configHotTable.updateSettings({
            cells: function (row, col) {
                var cellPrp = {};
                if (col === 6) {
                    cellPrp.renderer = ctrl.deleteButtonRenderer;
                }
                return cellPrp;
            }
        });
        this.utilsService.handleRenderHandson(this.configHotTable);
        this.showSummationTotal();
        this.recalcSummation();
    };
    TableInputMultComponent.prototype.showSummationTotal = function () {
        var ctrl = this;
        var newDiv = document.createElement("div");
        var idCustom = "hotTableActivity3";
        newDiv.setAttribute("id", idCustom);
        var currentDiv = document.getElementById("handson-gmf-summation");
        currentDiv.prepend(newDiv);
        var container = document.getElementById(idCustom);
        var totalRow = ["Total", ctrl.totalFunds, ctrl.totalExpense, ""];
        this.configSummationTable = new Handsontable(container, {
            data: [totalRow],
            rowHeaders: false,
            colWidths: [250, 40, 50, 25],
            filters: true,
            columnSorting: true,
            dropdownMenu: [
                "filter_by_value",
                "filter_action_bar",
                "filter_by_condition",
            ],
            stretchH: "all",
            height: "auto",
            licenseKey: "ee979-f3485-d8862-46b42-8ee23",
            afterGetColHeader: function (col, TH) {
                TH.className = 'htMiddle htCenter';
            },
            columns: [
                { className: "htCenter htMiddle", readOnly: true },
                { type: "numeric", className: "htCenter htMiddle", readOnly: true },
                { type: "numeric", className: "htCenter htMiddle", readOnly: true },
                { className: "htCenter htMiddle", readOnly: true },
            ]
        });
    };
    TableInputMultComponent.prototype.recalcSummation = function () {
        var ctrl = this;
        this.calcTotal(COL_CONSTS.GMF);
        this.calcTotal(COL_CONSTS.CU);
    };
    TableInputMultComponent.prototype.deleteButtonRenderer = function (instance, td, row, col, prop, value, cellProperties) {
        Handsontable.renderers.TextRenderer.apply(this, arguments);
        var ctrl = this;
        td.innerHTML = "<i style='color: black' class='fa fa-trash fa-sm'></i> ";
        return td;
    };
    TableInputMultComponent.prototype.calcTotal = function (col) {
        var dataGot = this.configData.data;
        if (col == COL_CONSTS.GMF) {
            var total = dataGot.reduce(function (a, b, idx, src) {
                return (a ? a : 0) + (b[COL_CONSTS.GMF] ? b[COL_CONSTS.GMF] : 0);
            }, 0);
            this.totalFunds = total;
            this.CGMFTable.setDataAtCell(1, 0, this.totalFunds);
            this.configSummationTable.setDataAtCell(0, 1, total);
        }
        if (col == COL_CONSTS.CU) {
            var total = dataGot.reduce(function (a, b, idx, src) {
                return (a ? a : 0) + (b[COL_CONSTS.CU] ? b[COL_CONSTS.CU] : 0);
            }, 0);
            this.totalExpense = total;
            this.CGMFTable.setDataAtCell(0, 0, this.totalExpense);
            this.configSummationTable.setDataAtCell(0, 2, total);
        }
    };
    TableInputMultComponent.prototype.deOverride = function () {
        if (!confirm("De-Override will erase all the input data. Do you want to proceed?")) {
            return;
        }
        this.deoverrideInput({
            targetNodeId: this.node._id,
            inputKey: this.tableDef.Key
        });
        this.reset();
    };
    TableInputMultComponent.prototype.afterSave = function (newComment) {
        var _this = this;
        this.tableInput.data.forEach(function (row) {
            _this.tableInput.colHeaders.forEach(function (h) {
                if (!h.isHeaderColumn) {
                    var cell = row[h.field];
                    cell.originValue = cell.value;
                }
            });
        });
        if (!this.commentHistory) {
            this.commentHistory = [];
        }
        this.commentHistory.push(newComment);
        this.reset();
        this.initComments(this.commentHistory);
    };
    TableInputMultComponent.prototype.save = function () {
        var _this = this;
        this.saving = true;
        var d = new Date();
        var tables = [];
        var saveOn = d.toDateString().substring(0, d.toDateString().length - 4) +
            d.toTimeString().split(' ')[0] + " " + d.getFullYear();
        this.tablesData.map(function (td, i) {
            var newComment = {
                SavedBy: _this.username,
                SavedOn: saveOn,
                lastVal: __assign(__assign({}, td.data.Val), { Data: td.originData.data }),
                msg: _this.currentComment.msg
            };
            var newData = td.data.Val.Data;
            var tableDefCopy = __assign(__assign({}, td.data), { Comment: [], Val: __assign(__assign({}, td.data.Val), { Data: newData }) });
            tables.push(tableDefCopy);
        });
        var gmfForSave = angular.copy(this.configData);
        var gmfSummationData = __spreadArray([], gmfForSave.data, true);
        this.smartorg.saveMultipleTableInputs(this.node._id, tables, gmfSummationData).then(function (ret) {
            _this.saving = false;
            if (ret && ret.msg && ret.msg.toUpperCase().startsWith('ERROR')) {
                _this.showAlert('danger', "Error!", ret.msg);
            }
            else {
                _this.gotDirty = false;
                _this.resetToNew();
                _this.tableInput.setNewData(_this.node, tables[0]);
                _this.tableInput2.setNewData(_this.node, tables[1]);
                _this.showAlert('success', "Saved!", ret.msg);
                if (_this.commonDataSaveCallback) {
                    _this.commonDataSaveCallback();
                }
                _this.lastUpdated();
            }
        })["catch"](function (err) {
            _this.saving = false;
            _this.showAlert('danger', "Error!", err);
        });
    };
    TableInputMultComponent.prototype.resetToNew = function () {
        for (var i = 0; i < this.tablesData.length; i++) {
            this.tablesData[i].originData = __assign(__assign({}, angular.copy(this.tablesData[i].data)), { Val: angular.copy(this.tablesData[i].data.Val) });
        }
        var tempConfData = angular.copy(this.configData);
        var configDataNew = __spreadArray([], tempConfData.data, true);
        this.configData = __assign(__assign({}, this.configData), { originData: angular.copy(configDataNew) });
    };
    TableInputMultComponent.prototype.reset = function () {
        for (var i = 0; i < this.tablesData.length; i++) {
            this.tablesData[i].data = __assign(__assign({}, angular.copy(this.tablesData[i].originData)), { Val: angular.copy(this.tablesData[i].originData.Val) });
            this.hotTables[i].loadData(this.tablesData[i].data.Val.Data);
            this.hotTables[i].render();
        }
        this.configData = __assign(__assign({}, this.configData), { data: angular.copy(this.configData.originData) });
        this.configHotTable.loadData(this.configData.data);
        this.recalcSummation();
        this.currentComment.msg = this.currentComment.originMsg;
        this.gotDirty = false;
    };
    TableInputMultComponent.prototype.exportCSV = function () {
        return this.tableInput.toCSVMerge('NA', __spreadArray(__spreadArray([], this.tableInput.data, true), this.tableInput2.data, true));
    };
    TableInputMultComponent.prototype.exportCSVEU = function () {
        return this.tableInput.toCSVMerge('EU', __spreadArray(__spreadArray([], this.tableInput.data, true), this.tableInput2.data, true));
    };
    TableInputMultComponent.prototype.getMenu = function () {
        var ctrl = this;
        return [{
                'name': 'Save',
                'class': 'btn btn-xs btn-danger',
                'show': function () {
                    var dirty = !ctrl.destroyed && ((ctrl.tableInput && ctrl.tableInput.isDirty && ctrl.tableInput.isValid) ||
                        (ctrl.currentComment && ctrl.currentComment.msg !== ctrl.currentComment.originMsg));
                    return ctrl.gotDirty && !ctrl.saving;
                },
                'callback': function () {
                    ctrl.save();
                }
            }, {
                'name': 'Reset',
                'class': 'btn btn-xs btn-primary',
                'show': function () {
                    return ctrl.gotDirty && !ctrl.saving;
                },
                'callback': function () {
                    ctrl.reset();
                }
            }, {
                'name': '',
                'class': 'btn btn-xs btn-danger',
                'icon': 'fa fa-spinner fa-spin fa-fw',
                'show': function () {
                    return ctrl.saving;
                }
            }, {
                'name': 'Export',
                'items': [{
                        'name': 'Table',
                        'callback': function () {
                            var csvData = ctrl.exportCSV();
                            Common.downloadCSV(csvData, ctrl.title);
                        }
                    }, {
                        'name': 'Table EU',
                        'callback': function () {
                            var csvData = ctrl.exportCSVEU();
                            Common.downloadCSV(csvData, ctrl.title);
                        }
                    }]
            }];
    };
    return TableInputMultComponent;
}());
angular.module(COMPONENT_NAME, [
    'ui.grid',
    'ui.grid.pinning',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'ui.grid.moveColumns',
    'ui.grid.edit',
    'ui.grid.cellNav',
    history_modal_component_1["default"],
    so_rich_text_box_component_1["default"],
]).component('tableInputMult', {
    template: require('./table-input-mult.component.html'),
    bindings: {
        smartorg: '=?',
        overrideInput: '&?',
        deoverrideInput: '&?',
        menu: '=',
        isCommonData: '@?',
        commonDataSaveCallback: '&?'
    },
    controller: TableInputMultComponent
});
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=table-input-mult.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/table-input-mult/table-input-mult.component.js